import React from 'react';

import { link, LinkButton, phone } from '../utils';

export default (
    <div>
        <p>
            Skadebehandling av forsikringssaker for helseforsikring behandles av vår samarbeidspartner Falck Helse.
            Falck Helse kan hjelpe deg med:
        </p>
        <ul>
            <li>Medisinske tjenester</li>
            <li>Fysikalske tjenester</li>
            <li>Psykologbistand</li>
            <li>Videolege via KRY</li>
        </ul>
        <p className="inline">
            Kontaktinformasjon <strong>Falck Helse</strong>
        </p>
        <a className="inline" href="https://eika.falckhelse.no/" target="_blank" rel="noopener noreferrer">
            Meld inn ditt behandlingsbehov her
        </a>
        <p className="inline">Telefon: {phone('21 89 75 35')}</p>
        <p className="inline">E-post: {link('eika@falck.com')}</p>

        <LinkButton href="https://eika.falckhelse.no/" external>
            Meld skade hos Falck Helse
        </LinkButton>
    </div>
);
